module.exports = __webpack_public_path__ + "img/P150T_weapon_89.c1f416c3.png";